import { BaseService } from "core/services";
import { NoteRouteService } from "application/tracking-case/services";

class NoteService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new NoteRouteService());
	}
}

export default NoteService;